import { GetterTree, ActionTree, MutationTree } from 'vuex'

class State {
    modalCountry: boolean = false
    modalContact: boolean = false
    modalContactMe: boolean = false
    modalContactAddress: boolean = false
    modalContactWhatsApp: boolean = false
}

const getters: GetterTree<State, any> = {
    modalCountry: (state) => state.modalCountry,
    modalContact: (state) => state.modalContact,
    modalContactMe: (state) => state.modalContactMe,
    modalContactAddress: (state) => state.modalContactAddress,
    modalContactWhatsApp: (state) => state.modalContactWhatsApp
}
console.log(getters)


const mutations: MutationTree<State> = {
    modalHandler: (state: any, payload) => {
        state[payload.name] = payload.boolean
        console.log(payload)
    }
}

const actions: ActionTree<State, any> = {}

export default {
    namespaced: true,
    state: new State(),
    mutations,
    actions,
    getters
}
